import * as R from 'ramda';
import type { OutcropOverviewTabQuery } from '~/apollo/generated/v4/graphql';
import { Carousel } from '~/components/ui/carousel';

type Outcrop = NonNullable<OutcropOverviewTabQuery['outcropGet']>;
type OutcropPicture = Outcrop['pictures'][number];

export function OutcropPicturesCarousel({
  pictures,
}: {
  pictures: OutcropPicture[];
}) {
  const sortedPictures = R.sortBy(pic => pic.priority ?? Infinity, pictures);

  return (
    <Carousel
      className="rounded-box h-48"
      items={sortedPictures.map(pic => ({
        src: pic.thumbnailUrl,
        alt: pic.name,
      }))}
    />
  );
}
